module.exports = __webpack_public_path__ + "static/img/lotterly.148b66da.png";